// export const BASE_URL = 'http://localhost:4040/';
// const LOCAL_URL = 'http://localhost:4040/';
export const BASE_URL = 'https://be.namasteapis.com/';

// export let BASE_URL = 'https://be.namasteapis.com/';

export const VIDEO_DETAILS = BASE_URL + 'web/v1/video/';
export const CREATOR_VIDEO_FEED = BASE_URL + 'api/v1/feed/';
export const VALORANT_MATCH_DETAILS = BASE_URL + 'api/v1/match/details/?gameName=valorant&matchId=';
export const NFT_LIST = BASE_URL + 'api/v1/nft/feed/?name=';
export const SAVE_BID = BASE_URL + 'api/v1/nfts/bid/';
export const NFT_DETAIL = BASE_URL + 'api/v1/nfts/creator/';
export const NFT_BUYERS = BASE_URL + 'api/v1/nfts/sales/?name=';
export const USER_NFTS = BASE_URL + 'api/v1/nfts/record-collection/';
export const PUBLIC_ADDRESS_TWITCH_CHECK = BASE_URL + 'twitch/v1/user/';
export const SAVE_FCM_TOKEN_URL = BASE_URL + 'api/v1/nft/fcm-token/';

export const CREATE_STRIPE_PAYMENT_INTENT = BASE_URL +  'nft-payments/v1/setup-payment-intent'
export const FETCH_STRIPE_PAYMENTS = BASE_URL + 'nft-payments/v1/payment-method';
export const DELETE_STRIPE_PAYMENTS = BASE_URL + 'nft-payments/v1/delete-payment-method';
export const CONFIRM_PAYMENT_METHOD = BASE_URL + 'nft-payments/v1/confirm/';

export const SAVE_BID_WEB2 = BASE_URL + 'api/v1/nft/stripe-bid/';
export const GET_OWNED_NFTS = BASE_URL + 'api/v1/nfts/owned/';
export const SAVE_EXTERNAL_WALLET = BASE_URL + 'api/v1/nft/external-wallet/';
export const FETCH_WALLET_DETAILS = BASE_URL + 'api/v1/nft/external-wallet/';
export const TRANSFER_NFT_ASSET = BASE_URL + 'api/v1/nft/claim/';
export const SAVE_SOCIAL_HANDLE = BASE_URL + 'api/v1/user/';
export const FETCH_SOCIAL_INFORMATION = BASE_URL + 'api/v1/user/info/';
export const PERK = BASE_URL + 'api/v1/perk/';
export const USER_PERK = BASE_URL + 'api/v1/user/perks/';
export const SAVE_BID_WEB2_INDIA = BASE_URL + 'api/v1/nft/razorpay-topup/'



export const MINT_NFT_FOR_USER = BASE_URL + 'api/v1/nft/mint/';
export const AIRDROP_NFT_FOR_USER = BASE_URL + 'api/v1/nft/glipbox/airdrop/';
export const GLIPBOX_LEFT = BASE_URL + 'api/v1/nft/glipbox/remaining/';
export const FETCH_NFT_METADATA = BASE_URL + 'metadata/v1/137/';



export const FETCH_USER_DIRECT_PERKS = BASE_URL + 'api/v1/perks/fetch-direct-user-perks/';
export const CREATE_DIRECT_USER_PERK = BASE_URL + 'api/v1/perks/create-direct-user-perk/';
export const CONSUME_DIRECT_USER_PERK = BASE_URL + 'api/v1/perks/consume-direct-user-perk/';

export const OVERLAY_DATA = BASE_URL + 'api/v1/overlay/';


export const CREATE_DIRECT_USER_PERK_INDIA = BASE_URL + 'api/v1/perks/create-direct-user-perk-india/';



export const FETCH_PAYMENT_CONFIG = BASE_URL + 'api/v1/nft/creator-config/';

export const OVERLAY_PERK_DATA = BASE_URL + 'api/v1/perks/?type=overlay';



export const CLAIMABLE_PERKS = BASE_URL + 'api/v1/perks/claimable-perks/';
export const CLAIM_FREE_PERK = BASE_URL + 'api/v1/perks/claim-perks/';
export const CLAIMABLE_PERK_CRON = BASE_URL + 'api/v1/perks/consume-direct-user-perk-overlay/';


export const RAZORPAY_PAYMENT_SUCCESS = BASE_URL + 'api/v1/nft/razorpay-success/';

//BASE_URL = 'http://localhost:4040/';
export const FETCH_USER_PAYMENT_CONFIG = BASE_URL + 'api/v1/perks/user-payment-config/';

export const SOCKET_URL = BASE_URL + 'websockets';
// export const SOCKET_URL = BASE_URL;
